import { ContractLanguageSection } from "components/ContractLanguageSection";
import {
  IRuleAttachment,
  RuleType,
} from "components/ContractLanguageSection/types";
import { Controller, useFormContext } from "react-hook-form";

interface IContractLanguageFieldProps {
  ruleType: RuleType;
  ruleId?: string;
  attachments?: IRuleAttachment[];
}

/** RHF wrapper around ContractLanguageSection used by MPPR / Case Rate / Package forms. */
export function ContractLanguageField({
  ruleType,
  ruleId,
  attachments,
}: IContractLanguageFieldProps) {
  const { control } = useFormContext();
  return (
    <Controller
      name="contractLanguage"
      control={control}
      render={({ field }) => (
        <ContractLanguageSection
          ruleType={ruleType}
          ruleId={ruleId}
          attachments={attachments}
          value={field.value || ""}
          onChange={field.onChange}
        />
      )}
    />
  );
}
